"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";
import { useCreateBot } from "@/hooks/api/useBots";
import { BotForm, BotFormValues } from "./BotForm";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";

import React from "react";

interface CreateBotDialogProps {
  trigger?: React.ReactElement;
}

export function CreateBotDialog({ trigger }: CreateBotDialogProps = {}) {
  const [open, setOpen] = useState(false);
  const { mutate: createBot, isPending } = useCreateBot();

  const router = useRouter();

  const onSubmit = (data: BotFormValues) => {
    createBot(data, {
      onSuccess: (newBot) => {
        setOpen(false);
        router.push(`/dashboard/bots/${newBot.id}/documents`);
      },
    });
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger render={
        trigger || (
          <Button>
            <Plus className="mr-2 h-4 w-4" />
            Create Bot
          </Button>
        )
      } />
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Create Bot</DialogTitle>
          <DialogDescription>
            Give your bot a name and description to get started.
          </DialogDescription>
        </DialogHeader>
        <BotForm onSubmit={onSubmit} isLoading={isPending} />
      </DialogContent>
    </Dialog>
  );
}
